// extracted by mini-css-extract-plugin
export default {"Regular":"OL8lA8Ux"};